import { queryOptions } from '@tanstack/react-query';
import { apiClient } from '@/api/axios';
import { API } from '@/api/endpoints';
import { STALE_TIME } from '@/api/staleTimes';
import { examBoardListSchema, type ExamBoard } from '../types/examBoard.types';

export const examBoardQueryKeys = {
  all: () => ['exam-boards'] as const,
  active: () => [...examBoardQueryKeys.all(), 'active'] as const,
};

export const activeExamBoardsQueryOptions = () =>
  queryOptions({
    queryKey: examBoardQueryKeys.active(),
    queryFn: async (): Promise<ExamBoard[]> => {
      const res = await apiClient.get(API.examBoard.listActive);
      return examBoardListSchema.parse(res.data);
    },
    staleTime: STALE_TIME,
  });
